import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FilterGroup } from '../../models/filter-group.model';
import { SearchPartner } from '../../models/search-partner.model';
import { FilterPayload } from '../../models/filter-payload.model';
import { Reference } from '../../models/reference';
import { environment } from '../../environment/environment';
import { EligibleSystemResponse } from '../../models/EligibleSystem.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private apisearchUrl = environment.backendApiConfiguration.api_url + 'search';
  private apiAllCountriesUrl = environment.backendApiConfiguration.api_url + 'filter/countries';
  private apiservicePartnerUrl = environment.backendApiConfiguration.api_url + 'filter/servicepartner';
  private apibusinessLinesUrl = environment.backendApiConfiguration.api_url + 'filter/bl';
  private apiAllUpdateMachinesUrl = environment.backendApiConfiguration.api_url + 'search/all-update-machines';

  constructor(private http: HttpClient) {}

  searchSystems(filter: FilterPayload, page: number = 0, pageSize: number = 100): Observable<EligibleSystemResponse> {
    const params = {
      page,
      pageSize
    };
    return this.http.post<EligibleSystemResponse>(this.apisearchUrl, filter, {
      headers: { 'Content-Type': 'application/json' },
      params
    });
  }

  searchAllUpdateMachines(filter: FilterPayload): Observable<EligibleSystemResponse> {
    return this.http.post<EligibleSystemResponse>(this.apiAllUpdateMachinesUrl, filter, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  getAllCountries(): Observable<Reference[]> {
    return this.http.get<Reference[]>(this.apiAllCountriesUrl);
  }

  getServicePartnerSuggestions(query: string): Observable<SearchPartner[]> {
    return this.http.get<SearchPartner[]>(this.apiservicePartnerUrl, {
      params: { query }
    });
  }

  getBusinessLines(): Observable<FilterGroup[]> {
    return this.http.get<FilterGroup[]>(this.apibusinessLinesUrl);
  }
}
